import { createContext } from "react";

// set the defaults
const OrderContext = createContext({
  order: null,
  setOrder: (order) => {}
});

export default OrderContext;